import { IAmendmentPageRequest } from '../../../../model/scp/contract/amendment/request/amendment-paged-request';

export type AmendmentListState = {
  parameters: IAmendmentPageRequest;
  contractId: number;
  processNumber?: string;
};

export enum ACTION_TYPES {
  setParameters = 'setParameters',
  setProcessNumber = 'setProcessNumber',
}

export const AmendmentListReducer = (state: AmendmentListState, action: any): AmendmentListState => {
  const { type, payload } = action;
  switch (type) {
    case ACTION_TYPES.setParameters:
      return {
        ...state,
        parameters: payload,
      };
    case ACTION_TYPES.setProcessNumber:
      return {
        ...state,
        processNumber: payload,
      };
    default:
      throw new Error(`Unhandled action type: ${type}`);
  }
}
